import { APP_NAME } from 'constants/settings';
import { is } from 'ramda';

// Ajoute un préfixe à la clé
export const genKey = (key) => `${APP_NAME}_${key}`;

// Vérifie que la clé est définie et est une chaîne de caractère
export const mustDefinedAndString = (value) => {
  if (!value) throw Error('Key must be defined');
  if (!is(String, value)) throw Error('Key must be a string');
  return value;
};

// Récupère une valeur du localStorage
export const getStorage = (key) => {
  mustDefinedAndString(key);
  const value = localStorage.getItem(key);
  return JSON.parse(value);
};

// Enregistre une valeur dans le localStorage
export const setStorage = (key, value) => {
  mustDefinedAndString(key);
  return localStorage.setItem(key, JSON.stringify(value));
};

// Retire une valeur du localStorage
export const removeStorage = (key) => {
  mustDefinedAndString(key);
  return localStorage.removeItem(key);
};
